<template>
    <div>
        <div class="form-group row">
            <label for="autocomplete" :class="`col-sm-${labelColSize}`">Find Address</label>
            <div :class="`col-sm-${inputColSize}`">
                <input type="text" id="autocomplete" class="form-control" @input="findAddress()" v-model="autocomplete.addressQueryString" placeholder="Search for address" />
                <ul v-if="autocomplete.autocompleteSuggestions.length" class="list-group autocomplete-suggestions">
                    <li v-for="(suggestion, index) in autocomplete.autocompleteSuggestions" :key="index" class="list-group-item" @click="chooseSuggestion(suggestion.Id)">{{ suggestion.Text }}, {{ suggestion.Description }}</li>
                </ul>
                <button v-if="address.countryCode && canShowExpandedAddress" class="btn show-manual-address" @click="expandManualAddress()">Enter address manually</button>
            </div>
        </div>

        <template v-if="sections.expandManualUkAddress">
            <div class="form-group row">
                <label for="address1" :class="`col-sm-${labelColSize}`">Address 1 <span class="text-danger">*</span></label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="address1" v-model="address.line">
                    <small v-if="addressErrors && addressErrors.line" class="text-danger">
                        {{ addressErrors.line[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="address2" :class="`col-sm-${labelColSize}`">Address 2</label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="address2" v-model="address.line2">
                    <small v-if="addressErrors && addressErrors.line2" class="text-danger">
                        {{ addressErrors.line2[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="address3" :class="`col-sm-${labelColSize}`">Address 3</label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="address3" v-model="address.line3">
                    <small v-if="addressErrors && addressErrors.line3" class="text-danger">
                        {{ addressErrors.line3[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="city" :class="`col-sm-${labelColSize}`">City <span class="text-danger">*</span></label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="city" v-model="address.city">
                    <small v-if="addressErrors && addressErrors.city" class="text-danger">
                        {{ addressErrors.city[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="province" :class="`col-sm-${labelColSize}`">County</label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="province" v-model="address.provinceName">
                    <small v-if="addressErrors && addressErrors.provinceName" class="text-danger">
                        {{ addressErrors.provinceName[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="postcode" :class="`col-sm-${labelColSize}`">Postcode <span class="text-danger">*</span></label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="postcode" v-model="address.postalCode">
                    <small v-if="addressErrors && addressErrors.postalCode" class="text-danger">
                        {{ addressErrors.postalCode[0] }}
                    </small>
                </div>
            </div>

            <div class="form-group row">
                <label for="country" :class="`col-sm-${labelColSize}`">Country <span class="text-danger">*</span></label>
                <div :class="`col-sm-${inputColSize}`">
                    <input :disabled="isBusy" type="text" class="form-control" id="country" v-model="address.country">
                    <small v-if="addressErrors && addressErrors.country" class="text-danger">
                        {{ addressErrors.country[0] }}
                    </small>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import AddressComponentValidationMixin from '../mixins/AddressComponentValidationMixin';
import {mapGetters} from 'vuex'
export default {
    props: {
        isBusy: Boolean(false),
        showExpandOption: Boolean(true),
        labelColSize: Number,
        inputColSize: Number
    },

    mixins: [
        AddressComponentValidationMixin
    ],

    computed: {
        ...mapGetters({
            address: 'AddressFormStore/GetAddress',
            autocomplete: 'AddressFormStore/GetAutocomplete',
            addressErrors: 'AddressFormStore/GetAddressErrors'
        }),

        canShowExpandedAddress() {
            return (typeof this.showExpandOption == 'boolean' && this.showExpandOption != null) ? this.showExpandOption : true
        }
    }
}
</script>